/**
 * Created by WorkAxis www.workaxis.in
 * Products page — AntCRM and client case studies.
 */
import React from 'react';
import "./style.css";
import {antcrmFeatures, antcrmProofPoints, clientWork, clients} from "./data";
import {useReveal, PageHero, CtaSection} from "./shared";

function CaseStudyCard({item, index}) {
    return (
        <article className="wx-case-study wx-reveal" style={{transitionDelay: `${index * 90}ms`}}>
            <a href={item.link} target="_blank" rel="noreferrer" className="wx-case-study-media">
                <img loading="lazy" src={item.image} alt={item.name}/>
            </a>
            <div className="wx-case-study-body">
                <h3>
                    <a href={item.link} target="_blank" rel="noreferrer">{item.name}</a>
                </h3>
                <dl className="wx-case-dl">
                    <div>
                        <dt>Problem</dt>
                        <dd>{item.problem}</dd>
                    </div>
                    <div>
                        <dt>What we built</dt>
                        <dd>{item.built}</dd>
                    </div>
                    <div>
                        <dt>Technology</dt>
                        <dd>
                            <div className="wx-chip-row">
                                {item.tech.map((t) => <span className="wx-chip is-small" key={t}>{t}</span>)}
                            </div>
                        </dd>
                    </div>
                    <div>
                        <dt>Outcome</dt>
                        <dd>{item.outcome}</dd>
                    </div>
                    <div>
                        <dt>Ownership</dt>
                        <dd className="wx-case-ownership-value">{item.ownership}</dd>
                    </div>
                </dl>
            </div>
        </article>
    );
}

export default function Products() {
    useReveal();

    return (
        <div>
            <PageHero
                kicker="Products & Work"
                title={<>Built with <span className="wx-grad-text">end-to-end ownership.</span></>}
                lead="We are a product company as much as a services partner. Case studies below show the
                      problem, what we owned, and what shipped — the same discipline we apply to AntCRM."
            />

            {/* ---------- AntCRM ---------- */}
            <section className="wx-section wx-section-tight">
                <div className="wx-container">
                    <div className="wx-product-featured wx-reveal">
                        <div className="wx-product-featured-body">
                            <div className="wx-product-tag">Flagship Product</div>
                            <h3>AntCRM</h3>
                            <p>
                                A customer relationship platform designed, engineered, and operated entirely
                                in-house — proof that we build and run real products, not just client projects.
                            </p>
                            <ul className="wx-product-points">
                                {antcrmProofPoints.map((p) => <li key={p}>{p}</li>)}
                            </ul>
                            <a href="https://antcrm.co" target="_blank" rel="noreferrer"
                               className="wx-btn wx-btn-primary">Explore AntCRM</a>
                        </div>
                        <div className="wx-product-featured-visual">
                            <div className="wx-ant-mark">
                                <div className="wx-ant-logo wx-grad-text">AntCRM</div>
                                <div className="wx-ant-domain">antcrm.co</div>
                            </div>
                        </div>
                    </div>

                    <div className="wx-services-grid is-four">
                        {antcrmFeatures.map((f, i) => (
                            <div key={f.name} className="wx-service-card wx-reveal"
                                 style={{transitionDelay: `${(i % 4) * 90}ms`}}>
                                <div className="wx-service-title">{f.name}</div>
                                <div className="wx-service-desc">{f.desc}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ---------- Client work ---------- */}
            <section className="wx-section">
                <div className="wx-container">
                    <div className="wx-section-head wx-reveal">
                        <div className="wx-kicker">Case studies</div>
                        <h2 className="wx-h2">Products we've built with partners.</h2>
                    </div>
                    <div className="wx-case-studies">
                        {clientWork.map((item, i) => (
                            <CaseStudyCard key={item.name} item={item} index={i}/>
                        ))}
                    </div>
                </div>
            </section>

            {/* ---------- Clients ---------- */}
            <section className="wx-section wx-section-tight">
                <div className="wx-container">
                    <div className="wx-section-head is-center wx-reveal">
                        <div className="wx-kicker">Trusted by</div>
                    </div>
                    <div className="wx-clients-row wx-reveal">
                        {clients.map((client) => (
                            <img key={client.name} src={client.image} loading="lazy" alt={client.name}/>
                        ))}
                    </div>
                </div>
            </section>

            <CtaSection
                title={<>Have a process that's <span className="wx-grad-text">hard to scale?</span></>}
                text="Share your workflow — we'll suggest what can realistically be automated or built."
                primaryLabel="Get a solution assessment"
            />
        </div>
    );
}
